import get from 'lodash/get';
import { createSelector } from '@reduxjs/toolkit';

export const getIsLoading = (state) => get(state, 'quoteDepositPay.isLoading');
export const getQuoteCreated = (state) => get(state, 'quoteDepositPay.quoteCreated');
export const getQuoteDepositPay = (state) => get(state, 'quoteDepositPay.quote');
export const getQuoteDepositPayError = (state) => get(state, 'quoteDepositPay.error');
export const getQuoteDepositPayReference = (state) => get(state, 'quoteDepositPay.quote.stay.quoteReference');
export const getQuoteDepositPayCharges = createSelector(getQuoteDepositPay, (quote) => get(quote, 'offer.charges', {}));
